module.exports = __webpack_public_path__ + "static/media/016.8aa8f7fa.jpg";